<template>
  <div>
    <!-- Panic Button Card -->
    <div class="panic-button-section card p-2 mb-1">
      <div class="d-flex align-items-center gap-1">
        <img
          v-if="section.image_url"
          :src="section.image_url"
          class="panic-button-section__image"
          alt="Bego to the Rescue"
        >
        <div
          class="panic-button-section__text flex-grow-1"
          v-html="section.description"
        />
        <button
          class="panic-button-section__btn btn-danger rounded-circle border-0"
          title="Send OSH alert"
          @click="openModal"
        >
          <i data-feather="bell" />
        </button>
      </div>
    </div>

    <!-- Confirm Modal -->
    <div
      class="modal fade text-start"
      :class="showModal ? 'show' : ''"
      :style="{ display: showModal ? 'block' : 'none' }"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-dark">
              Send OSH notification
            </h5>
            <button
              type="button"
              class="btn-close"
              :disabled="sending"
              @click="closeModal"
            />
          </div>
          <div class="modal-body">
            <p>Are you sure you want to send a notification to the OSH team?</p>
            <div class="mt-1 mb-1">
              <label class="form-label">Title <span class="text-danger">*</span></label>
              <input
                v-model="title"
                type="text"
                class="form-control"
                placeholder="Brief description of the issue..."
                :disabled="sending"
                maxlength="255"
              >
            </div>
            <div class="mt-1">
              <label class="form-label">Reason <span class="text-muted">(optional)</span></label>
              <textarea
                v-model="reason"
                class="form-control"
                rows="3"
                placeholder="Describe the reason for this alert..."
                :disabled="sending"
              />
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-outline-secondary"
              :disabled="sending"
              @click="closeModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-danger"
              :disabled="sending"
              @click="sendNotification"
            >
              <span v-if="sending">
                <span class="spinner-border spinner-border-sm me-50" /> Sending...
              </span>
              <span v-else>Send notification</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showModal"
      class="offcanvas-backdrop fade show"
      @click="closeModal"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    section: { type: Object, required: true },
  },
  data() {
    return {
      showModal: false,
      sending: false,
      title: '',
      reason: '',
    }
  },
  methods: {
    openModal() {
      this.title = ''
      this.reason = ''
      this.showModal = true
    },
    closeModal() {
      if (this.sending) return
      this.showModal = false
    },
    async sendNotification() {
      if (!this.title.trim()) {
        Vue.swal('Title required', 'Please enter a title for this alert.', 'warning')
        return
      }
      this.sending = true
      try {
        await this.$http.post(`${this.$groupUrl}/cae/panic-notify`, {
          title: this.title.trim(),
          reason: this.reason || null,
        })
        this.showModal = false
        Vue.swal('Notification sent successfully', 'The OSH team has been notified and will contact you shortly.', 'success')
      } catch {
        Vue.swal('Error', 'Could not send the notification. Please try again.', 'error')
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.panic-button-section {
  background: #fff;
}
.panic-button-section__image {
  width: 160px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 4px;
}
.panic-button-section__text {
  font-size: 0.9rem;
  padding: 0 1.5rem;
  align-self: center;
}
.panic-button-section__btn {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  align-self: flex-end;
}
</style>
